module.exports = __webpack_public_path__ + "img/jaune-1.fe086872.png";